<template>
  <transition name="fade">
    <div class="notification is-print-hide" v-if="notification">
      <div class="close" @click="closeNotification"><img :src="require('@/assets/img/modal_close.png')" alt="" /></div>
      <div class="notification_box">
        <div class="header">你有新的处方需要处理</div>
        <div class="hand" @click="handlePrescription">
          立即操作
          <img src="" alt="" />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    notification() {
      return this.$store.getters.notification;
    }
  },
  methods: {
    handlePrescription() {
      this.closeNotification();
      this.$router.push({ path: `/waitPrescriptionListMid` });
    },
    closeNotification() {
      this.$store.dispatch('global/SETnotification', false);
    }
  }
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.notification {
  position: absolute;
  z-index: 10;
  bottom: 48px;
  right: 0;
  .close {
    right: 14px;
    top: 10px;
    cursor: pointer;
    position: absolute;
  }
  .notification_box {
    padding: 16px;
    padding-right: 36px;
    background: #fff;
    .header {
      color: #707070;
      font-size: 14px;
      padding-bottom: 10px;
    }
    .hand {
      font-size: 14px;
      color: #ebb436;
      cursor: pointer;
    }
  }
}
</style>
